import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue";
const _hoisted_1 = { class: "summary-controls" };
const _hoisted_2 = {
    key: 0,
    class: "summary-controls__regen-group"
};
const _hoisted_3 = {
    key: 0,
    class: "summary-controls__outdated-container"
};
const _hoisted_4 = {
    key: 0,
    class: "summary-controls__outdated-text"
};
const _hoisted_5 = ["aria-label", "aria-describedby"];
const _hoisted_6 = { class: "summary-controls__regenerate" };
const _hoisted_7 = ["aria-label"];
import { vTooltip } from "@/common/directives/tip-directive";
import { useClipboard } from "@vueuse/core";
import { computed, useId } from "vue";
// Components
import PulsatingDot from "@/common/components/PulsatingDot.vue";
import SvgIcon from "@/common/components/SvgIcon.vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'SummaryControls',
    props: {
        isSummaryOutdated: { type: Boolean },
        outdatedTooltip: {},
        outdatedText: {},
        preventRegenerate: { type: Boolean },
        copyText: {}
    },
    emits: ["regenerate"],
    setup(__props) {
        const props = __props;
        const { copy, copied: isCopying } = useClipboard();
        const copyToClipboard = () => {
            if (props.copyText)
                copy(props.copyText);
        };
        const describeId = `describe-regenerate-${useId()}`;
        const showCopy = computed(() => props.copyText !== undefined);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!_ctx.preventRegenerate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_ctx.isSummaryOutdated)
                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createVNode(PulsatingDot),
                                (_ctx.outdatedText)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.outdatedText), 1))
                                    : _createCommentVNode("", true)
                            ])), [
                                [_unref(vTooltip), _ctx.isSummaryOutdated && _ctx.outdatedText ? _ctx.outdatedTooltip : undefined]
                            ])
                            : _createCommentVNode("", true),
                        _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "summary-controls__button",
                            "aria-label": _ctx.$t('Regenerate'),
                            "aria-describedby": _ctx.isSummaryOutdated ? describeId : undefined,
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.$emit('regenerate')), ["stop"])),
                            onKeydown: [
                                _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => { }, ["stop"]), ["enter"])),
                                _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => { }, ["stop"]), ["space"]))
                            ]
                        }, [
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(SvgIcon, {
                                    src: "/svg/dropdown-icons.svg",
                                    icon: "icon-ai-regen"
                                }),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("Regenerate")), 1)
                            ])
                        ], 40, _hoisted_5)), [
                            [_unref(vTooltip), _ctx.isSummaryOutdated ? _ctx.outdatedTooltip : undefined]
                        ]),
                        (_ctx.isSummaryOutdated)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                id: describeId,
                                class: "sr-only"
                            }, _toDisplayString(_ctx.outdatedTooltip), 1))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                (showCopy.value)
                    ? _withDirectives((_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "summary-controls__button",
                        "aria-label": _ctx.$t('Copy to clipboard'),
                        onClick: _withModifiers(copyToClipboard, ["stop"]),
                        onKeydown: [
                            _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => { }, ["stop"]), ["enter"])),
                            _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => { }, ["stop"]), ["space"]))
                        ]
                    }, [
                        _createVNode(SvgIcon, { icon: "icon-copy" }),
                        _createElementVNode("span", null, _toDisplayString(_unref(isCopying) ? _ctx.$t("Copied") : _ctx.$t("Copy")), 1)
                    ], 40, _hoisted_7)), [
                        [
                            _unref(vTooltip),
                            _ctx.$t('Copy to clipboard'),
                            void 0,
                            { sw: true }
                        ]
                    ])
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
